export default __webpack_public_path__ + "static/media/Group47@2x.67daf973.png";